import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { motion } from "motion/react";
import DialogMotionTransition from "./DialogMotionTransition";
import closeIcon from "../../../assets/images/close_icon.svg";
import { setContext } from "../../../store/omrUpload/omrUpload.slice";
import styles from "./UploadResponsesModal.module.css";

const UploadResponsesModal = ({
  isOpen,
  onClose,
  selectedEvent,
  schoolDetails,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleUploadOmrPdf = () => {
    // Set context in Redux
    dispatch(
      setContext({
        school: schoolDetails,
        event: selectedEvent,
      })
    );
    onClose();
    navigate("/pdf-upload");
  };

  const handleSamplePdfClick = (event) => {
    event.preventDefault();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={window.innerWidth < 768}
      slots={{ transition: DialogMotionTransition }}
      slotProps={{
        paper: { className: styles.dialogPaper },
      }}
    >
      <DialogTitle className={styles.modalHeader}>
        <div className={styles.headerTextGroup}>
          <h2 className={styles.modalTitle}>
            Upload Offline Responses OMR PDF
          </h2>
        </div>
        <button
          type="button"
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close"
        >
          <img src={closeIcon} alt="" aria-hidden="true" />
        </button>
      </DialogTitle>
      <DialogContent className={styles.modalContent}>
        <motion.div
          className={styles.optionsGrid}
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0, y: 16 },
            visible: {
              opacity: 1,
              y: 0,
              transition: { type: "spring", stiffness: 280, damping: 26 },
            },
          }}
        >
          <div className={styles.optionCard}>
            <div className={styles.optionActions}>
              <button
                type="button"
                className={`${styles.actionButton} ${styles.primaryAction}`}
                onClick={handleUploadOmrPdf}
              >
                Upload OMR PDF
              </button>
              <button
                type="button"
                className={`${styles.actionButton} ${styles.secondaryAction}`}
                onClick={handleSamplePdfClick}
              >
                View Sample PDF
              </button>
            </div>
            <ul className={styles.guidelinesList}>
              <li>File size must be less than 100MB.</li>
              <li>Supported format: .pdf</li>
              <li>View sample PDF for reference.</li>
            </ul>
          </div>
        </motion.div>
      </DialogContent>
      <div className={styles.modalFooter}>
        <button
          type="button"
          className={styles.closeBtn}
          onClick={onClose}
          aria-label="Close modal"
        >
          Close
        </button>
      </div>
    </Dialog>
  );
};

export default UploadResponsesModal;
